// tslint:disable:max-line-length

import React from 'react';

export const DatatypePhone = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M15.4,0.8L12.2,0c-0.4-0.1-0.7,0.1-0.9,0.4L9.8,4c-0.1,0.3,0,0.7,0.2,0.9l1.9,1.5c-1.1,2.4-3.1,4.4-5.5,5.5 L4.8,10C4.6,9.8,4.3,9.7,4,9.8l-3.5,1.5c-0.3,0.1-0.5,0.5-0.4,0.9l0.7,3.2c0,0.4,0.3,0.6,0.7,0.6C9.5,16,16,9.5,16,1.5 C16,1.2,15.8,0.8,15.4,0.8z" />
    </svg>
  );
};
